/** Cambio de clave. Lógica compartida por las dos variantes de Ajustes. */

import { useState } from 'react';

import { ErrorAPI, pedir } from '../datos/api.ts';

/** Tiene que coincidir con MINIMO_CLAVE de la API; el servidor lo valida igual. */
export const MINIMO_CLAVE = 8;

export function useClave() {
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [repetida, setRepetida] = useState('');
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [listo, setListo] = useState(false);

  const coinciden = nueva.length > 0 && nueva === repetida;
  const largoOk = nueva.length >= MINIMO_CLAVE;
  const valido = actual.length > 0 && largoOk && coinciden && nueva !== actual;

  const cambiar = async (): Promise<boolean> => {
    setEnviando(true);
    setError(null);
    setListo(false);
    try {
      await pedir('/auth/clave', { metodo: 'POST', cuerpo: { claveActual: actual, claveNueva: nueva } });
      setActual('');
      setNueva('');
      setRepetida('');
      setListo(true);
      return true;
    } catch (e) {
      setError(e instanceof ErrorAPI ? e.message : 'No se pudo cambiar la clave.');
      return false;
    } finally {
      setEnviando(false);
    }
  };

  /** Qué le falta, en una frase, para no dejar el botón deshabilitado sin explicación. */
  const queFalta = (): string | null => {
    if (actual.length === 0) return 'Falta la clave actual.';
    if (!largoOk) return `La clave nueva necesita al menos ${MINIMO_CLAVE} caracteres.`;
    if (nueva === actual) return 'La clave nueva es igual a la actual.';
    if (!coinciden) return 'Las dos claves nuevas no coinciden.';
    return null;
  };

  return {
    actual,
    setActual,
    nueva,
    setNueva,
    repetida,
    setRepetida,
    enviando,
    error,
    listo,
    valido,
    queFalta,
    cambiar,
  };
}
